<template>
    <div>
        <v-data-table
                :items="dataReport.table1"
                hide-default-footer
                class="elevation-1"
        >
            <template v-slot:header>
                <tr>
                    <th class="th_td" rowspan="2">Наименование муниципального образования</th>
                    <th rowspan="2">Наименование государственной услуги</th>
                    <th colspan="5">Количество принятых заявлений (запросов) на предоставление государственных услуг</th>
                    <th colspan="3">Количество решений по принятым заявлениям</th>
                    <th rowspan="2">Количество недостатков по принятым заявлениям через МФЦ</th>
                </tr>
                <tr>
                    <th>ВСЕГО</th>
                    <th>в том числе непосредственно через орган или подведомственную  организацию</th>
                    <th>в том числе через ЕПГУ</th>
                    <th>в том числе через почтовые организации</th>
                    <th>в том числе через МФЦ</th>
                    <th>ВСЕГО принято решений</th>
                    <th>положительных решений</th>
                    <th>отрицательных решений (отказов)</th>
                </tr>
                <tr>
                    <th>1</th>
<!--                    <th>2</th>-->
                    <th>3</th>
                    <th>4=5+6+7+8</th>
                    <th>5</th>
                    <th>6</th>
                    <th>7</th>
                    <th>8</th>
                    <th>9=10+11</th>
                    <th>10</th>
                    <th>11</th>
                    <th>12</th>
                </tr>
            </template>
            <template
                    v-slot:body="{ items }"
            >
                <tbody>
                <tr
                        v-for="item in items"
                        :key="item.name"
                >
                    <td>{{ item.department }}</td>
                    <td>{{item.service}}</td>
                    <td class="td_sum">{{1*item.coll_1 + 1*item.coll_2 + 1*item.coll_3 + 1*item.coll_4}}</td>
                    <td>
                        <v-text-field
                                v-model.trim="item.coll_1"
                                type="text"
                                :disabled="disableReport"
                        ></v-text-field>
                    </td>
                    <td>
                        <v-text-field
                                v-model.trim="item.coll_2"
                                type="text"
                                :disabled="disableReport"
                        ></v-text-field>
                    </td>
                    <td>
                        <v-text-field
                                v-model.trim="item.coll_3"
                                type="text"
                                :disabled="disableReport"
                        ></v-text-field>
                    </td>
                    <td>
                        <v-text-field
                                v-model.trim="item.coll_4"
                                type="text"
                                :disabled="disableReport"
                        ></v-text-field>
                    </td>
                    <td class="td_sum">{{1*item.coll_5 + 1*item.coll_6}}</td>
                    <td>
                        <v-text-field
                                v-model.trim="item.coll_5"
                                type="text"
                                :disabled="disableReport"
                        ></v-text-field>
                    </td>
                    <td>
                        <v-text-field
                                v-model.trim="item.coll_6"
                                type="text"
                                :disabled="disableReport"
                        ></v-text-field>
                    </td>
                    <td>
                        <v-text-field
                                v-model.trim="item.coll_7"
                                type="text"
                                :disabled="disableReport"
                        ></v-text-field>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-data-table>
        <v-card-actions
                v-if="this.$route.params.report_id !== 'new'"
        >
            <v-spacer></v-spacer>
            <v-btn
                    @click.native="get_report('get_report_monitoring_msss_02', 'Отчет.xlsx')">Отчет
            </v-btn>
        </v-card-actions>
    </div>
</template>

<script>
export default {
  name: 'monitoringMsss02',
  props: {
    dataReport: {
      type: Object,
      default: function () {
        return { table1: [] }
      }
    },
    disableReport: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  methods: {
    get_report (urlFile, filename) {
      this.$store.dispatch('reportingReport/downloadFile',
        { id: this.$route.params.report_id, urlFile, filename })
    }
  }
}
</script>

<style scoped>
    table, td, th {
        /*text-align: left;*/
        /*padding: 1px;*/
        border: solid black 1px;
    }
    th {
        vertical-align: top;
        /*text-align: center;*/
    }
    td {
        vertical-align: bottom;
    }
    .td_sum {
        padding-bottom: 27px;
        font-weight: bold;
    }
    .bloc_inline
    {
        display:inline-block;
    }
    .bloc
    {
        border: 1px solid gray
    }

</style>
